import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ServiceModule } from '../services.module/services.module';
import { ElementsModule } from '../elements.component.module/elements.module';
import { PipeModule } from '../pipes.module/pipes.module';

import { BenutzerverwaltungModule } from './benutzerverwaltung/benutzerverwaltung.module';
import { BuergschaftenModule } from './buergschaften/buergschaften.module';
import { CockpitModule } from './cockpit/cockpit.module';
import { DownloadsModule } from './downloads/downloads.module';
import { KundenAuswahlModule } from './kunden-auswahl/kunden-auswahl.module';
import { MeineDatenModule } from './meine-daten/meine-daten.module';
import { PosteingangModule } from './posteingang/posteingang.module';
import { VertraegeModule } from './vertraege/vertraege.module';
import { InsightSharedModule } from './insight-shared/insight-shared.module';
import { InsightRoutingModule } from './insight-routing.module';

@NgModule({
    declarations: [
    ],
    imports: [
        InsightRoutingModule,
        BenutzerverwaltungModule,
        BuergschaftenModule,
        CockpitModule,
        DownloadsModule,
        KundenAuswahlModule,
        MeineDatenModule,
        PosteingangModule,
        VertraegeModule,
        InsightSharedModule,
        FormsModule,
        ServiceModule,
        ElementsModule,
        PipeModule
    ],
    exports: [
        InsightSharedModule
    ],
    bootstrap: [],
})
export class InsightModule {
}
